/**
 * @fileoverview GET handler for the "/data_objects/import_staging_records" endpoint.
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsImportStagingRecords } from "./constants";
import type { CustomObjectsImportStagingRecordsParams, CustomObjectsImportStagingRecordsResult } from "./types";
import { isCustomObjectsImportStagingRecordsResult } from "./validators";

export const getDataTableCustomObjectsImportStagingRecords = reactQueryTableFetcherAdapter(
  customObjectsImportStagingRecords,
  (
    signal: AbortSignal,
    { appGroupId, statuses, limit = 12, start = 0 }: CustomObjectsImportStagingRecordsParams
  ): Promise<CustomObjectsImportStagingRecordsResult> => {
    return fetch<CustomObjectsImportStagingRecordsResult>(
      "/data_objects/import_staging_records",
      "GET",
      {
        app_group_id: appGroupId,
        status: statuses,
        limit,
        start,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isCustomObjectsImportStagingRecordsResult
);
